import React, { Children, memo } from 'react';
import { ChevronRight } from 'lucide-react';
type Category = {
  name: string;
  url: string;
};
const categories: Category[] = [{
  name: 'Anti-Aging Vitamins',
  url: 'https://www.bestvitaminsforall.com/bestantiagingvitamins'
}, {
  name: 'Body Care Products',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-body-care-products.html'
}, {
  name: 'Memory Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-brain-memory-supplements.html'
}, {
  name: 'Children Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-children-supplements.html'
}, {
  name: 'Digestion Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-digestion-supplements.html'
}, {
  name: 'Energy Vitamins & Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-energy-vitamins-supplements.html'
}, {
  name: 'Eyes & Vision',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-eyes-vision.html'
}, {
  name: 'Fiber Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-fiber-supplements.html'
}, {
  name: 'Heart Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-heart-supplements.html'
}, {
  name: 'Herbal Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-herbal-supplements.html'
}, {
  name: 'Home Care Products',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-home-care-products.html'
}, {
  name: 'Immune Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-immune-supplements.html'
}, {
  name: 'Mineral Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-mineral-supplements.html'
}, {
  name: 'Multi-Vitamins',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-multi-vitamins.html'
}, {
  name: 'Natural Oils',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-natural-oils.html'
}, {
  name: 'Single Vitamins',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-single-vitamins.html'
}, {
  name: 'Skin Care Products',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-skin-care.html'
}, {
  name: 'Sports Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-sports-supplements.html'
}, {
  name: 'Vegan Vitamins & Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-vegan-vitamins-supplements.html'
}, {
  name: 'Vegetarian Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-vegetarian-supplements.html'
}, {
  name: 'Weight Loss Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-weight-loss-supplements.html'
}, {
  name: 'Protein Shakes',
  url: 'https://www.bestvitaminsforall.com/15m8/neolife-protein-shakes.html'
}, {
  name: 'Organic Vitamins',
  url: 'https://www.bestvitaminsforall.com/15m8/organic-vitamins.html'
}];
export function ProductCategories() {
  return <section className="bg-[#f9fafb] py-12 lg:py-16 border-t border-gray-100" data-id="element-122">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-123">
        <div className="flex items-center gap-4 mb-8" data-id="element-124">
          <h2 className="text-xl lg:text-2xl font-bold text-gray-900" data-id="element-125">
            Product Categories
          </h2>
          <div className="h-0.5 bg-[#9fd23d] flex-grow max-w-[80px]" data-id="element-126"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2" data-id="element-127">
          {categories.map(category => <a key={category.name} href={category.url} className="flex items-center justify-between py-3 px-4 bg-white rounded border border-gray-100 hover:border-[#0e7be1] transition-colors group" data-id="element-128">
              <span className="text-sm text-gray-700 group-hover:text-[#0e7be1] transition-colors" data-id="element-129">
                {category.name}
              </span>
              <ChevronRight className="h-4 w-4 text-gray-300 group-hover:text-[#0e7be1] transition-colors flex-shrink-0" data-id="element-130" />
            </a>)}
        </div>
      </div>
    </section>;
}